import Checklist from '@repo/datalayer/store/models/Checklist'
import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { useRouter } from '../../hooks/router'
import { useStore } from '../../hooks/store'
import { CompletedChecklistView } from './CompletedChecklistView'
import { LiveChecklistView } from './LiveChecklistView'

export const ChecklistPage = observer(function ChecklistPage() {
  const store = useStore()
  const [checklist, setChecklist] = useState<Checklist | null>(null)
  const router = useRouter()
  const { id } = router.router.params as { id: string }

  useEffect(() => {
    setChecklist(null)
    store.fetchChecklist(id).then((checklist) => {
      if (checklist) {
        console.log(checklist)
        setChecklist(checklist)
      } else {
        // something went wrong
      }
    })
  }, [id])

  if (!checklist) return null
  if (checklist.complete) {
    return <CompletedChecklistView key={id} checklist={checklist} />
  }

  return <LiveChecklistView key={id} checklist={checklist} />
})
